import { render } from "./j-loading.vue?vue&type=template&id=18cf1569&scoped=true"
import script from "./j-loading.vue?vue&type=script&lang=js"
export * from "./j-loading.vue?vue&type=script&lang=js"

import "./j-loading.vue?vue&type=style&index=0&id=18cf1569&lang=less&scoped=true"

import exportComponent from "/Users/jiangwen/GitHub/xiamao-mall/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18cf1569"]])

export default __exports__